import {gql} from "@irati/utils/gql"
import fullPaymentOrder from "@irati/payments/services/fragments/fullPaymentOrder"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation Topup(
    $tenantId: String!
    $currency: String!
    $amount: Float!
    $walletUuid: String!
    $walletOwnerUuid: String
    $type: String!
    $poNumber: String
    $targetCurrency: String
  ) {
    createTopUp(
      tenantId: $tenantId
      currency: $currency
      amount: $amount
      walletUuid: $walletUuid
      walletOwnerUuid: $walletOwnerUuid
      type: $type
      poNumber: $poNumber
      targetCurrency: $targetCurrency
    ) {
      uuid
      amount
      currency
      payment {
        status
        type
        paymentOrderUuid
        invoiceUuid
        poNumber
        invoiceNumber
      }
      metadata {
        createdAt
      }
      paymentOrder {
        ...fullPaymentOrder
      }
      totalToPay
    }
  }
  ${fullPaymentOrder}
`

export const createTopUpKey = getQueryNames(query)[0]

export default query
